import { render, staticRenderFns } from "./ClubBeneficios.vue?vue&type=template&id=4cb0701e&scoped=true&"
var script = {}
import style0 from "./ClubBeneficios.vue?vue&type=style&index=0&id=4cb0701e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb0701e",
  null
  
)

export default component.exports